import { inject, Provider } from '@angular/core';
import { IScanControllerToken, ScanComponentControllerToken } from '@simOn/common/scan';
import { AssetComponentsControllerService } from '../controllers-services/asset-components-controller.service';
import { EventComponentsControllerService } from '../controllers-services/event-components-controller.service';
import { NavvisPoiControllerService } from '../controllers-services/navvis-poi-controller.service';
import { SceneComponentsControllerService } from '../controllers-services/scene-components-controller.service';
import { TicketComponentControllerService } from '../controllers-services/ticket-component-controller.service';
import { WidgetControllerService } from '../controllers-services/widget-controller.service';

export function provideScanControllers(): Provider[] {
  return [
    AssetComponentsControllerService,
    EventComponentsControllerService,
    SceneComponentsControllerService,
    TicketComponentControllerService,
    WidgetControllerService,
    NavvisPoiControllerService,
    {
      provide: ScanComponentControllerToken,
      deps: [
        AssetComponentsControllerService,
        EventComponentsControllerService,
        SceneComponentsControllerService,
        TicketComponentControllerService,
        WidgetControllerService,
        NavvisPoiControllerService
      ],
      useFactory: (
        asset: AssetComponentsControllerService,
        event: EventComponentsControllerService,
        scene: SceneComponentsControllerService,
        ticket: TicketComponentControllerService,
        widget: WidgetControllerService,
        poi: NavvisPoiControllerService
      ) => {
        const scanManagerService = inject(IScanControllerToken);
        const providers = [];
        //if not cointain hasMatteprort it is navvis
        !('hasMatterport$' in scanManagerService) && providers.push(poi);

        return [...providers, asset, event, widget, scene, ticket];
      }
    }
  ];
}
